var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "30", height: "60", viewBox: "0 0 64 60", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#a)", fill: "#fff" },
      React.createElement("path", { d: "M52.627 37.62H11.38v2.201h41.245v-2.2z" }),
      React.createElement("path", { d: "M57.802 15.725H9.431C10.119 8.152 16.426 2.2 24.08 2.2h5.001V0h-5.001C15.215 0 7.945 6.92 7.249 15.725H6.198c-3.429 0-6.198 2.81-6.198 6.28V60h64V22.006c0-3.471-2.776-6.281-6.198-6.281zm4.023 42.074H2.175V22.006c0-2.253 1.805-4.08 4.023-4.08h51.604c2.218 0 4.023 1.827 4.023 4.08v35.793z" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h64v60H0z" })
      )
    )
  );
});